import { useState, useEffect, useCallback } from 'react';
import * as faceapi from 'face-api.js';

const MODELS_URL = '/models';

/**
 * Carga los modelos de face-api.js y expone detectFace().
 */
export function useFaceApi() {
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [loadError, setLoadError]       = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function loadModels() {
      try {
        await Promise.all([
          faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL),
          faceapi.nets.faceLandmark68Net.loadFromUri(MODELS_URL),
          faceapi.nets.faceRecognitionNet.loadFromUri(MODELS_URL),
        ]);
        if (!cancelled) setModelsLoaded(true);
      } catch (err) {
        console.error('❌ Error cargando modelos face-api:', err);
        if (!cancelled) setLoadError('No se pudieron cargar los modelos de reconocimiento facial.');
      }
    }
    loadModels();
    return () => { cancelled = true; };
  }, []);

  /**
   * Detecta el rostro en el video y retorna el descriptor de 128 puntos.
   * @param {HTMLVideoElement} videoEl
   * @returns {object|null} detection con descriptor y landmarks
   */
  const detectFace = useCallback(async (videoEl) => {
    if (!modelsLoaded || !videoEl) return null;
    try {
      const detection = await faceapi
        .detectSingleFace(videoEl, new faceapi.TinyFaceDetectorOptions({ scoreThreshold: 0.5 }))
        .withFaceLandmarks()
        .withFaceDescriptor();
      return detection || null;
    } catch {
      return null;
    }
  }, [modelsLoaded]);

  return { modelsLoaded, loadError, detectFace };
}

export default useFaceApi;
